import { AuxiliumComponent } from "../auxilium-component";

export default class SidebarHeader extends AuxiliumComponent {
	static observable = ["icon", "icon-colour"];

	parsedCallback() {
		if (this.icon) {
			const headerIcon = document.createElementWithContents("chip-icon", null, { icon: this.icon });
			if (this.iconColour) { headerIcon.colour = this.iconColour; }

			this.prepend(headerIcon);
		}
	}
}
